module.exports = __webpack_public_path__ + "img/Image 3.e0417ded.png";